module.exports = __webpack_public_path__ + "img/text.983984f5.png";